import React, { useState, useEffect } from "react";
import type { ColumnsType } from "antd/es/table";
import "./searchPage.css";
import { Pagination, PaginationProps } from "antd";
import {
  Button,
  Col,
  message,
  Form,
  Input,
  Row,
  Space,
  Typography,
  Table,
  Upload,
  Select,
} from "antd";
import { toast } from "react-toastify";
import {
  InboxOutlined,
  UploadOutlined,
  SearchOutlined,
} from "@ant-design/icons";

import { useNavigate } from "react-router-dom";
import { renderMessage } from "../Common/notificationUtils";
import { useAuth } from "../../Context/authContext";
import { getApi } from "../../Api/Api";
import { countValues } from "../Common/Utils";
import StackedText from "../Common/StackedText";
import SourceValue from "../Common/SourceValue";
const { TextArea, Search } = Input;
const { Title, Text } = Typography;
const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 14 },
};
const searchInitialState = {
  loading: false,
  error: "",
  projects: [],
  totalPages: 0,
  totalItems: 0,
  searchTerm: "",
  itemsPerPage: "10",
  pageNumber: 1,
  sortColumns: "modifiedOn",
  sortOrder: "",
  searchWithin: ["ALL"],
  tableSearch: {},
};

function SearchPage() {
  const [searchFilters, setSearchFilters] =
    useState<searchState>(searchInitialState);
  const navigate = useNavigate();
  const { user } = useAuth();
  const [loading, setLoading] = useState<boolean>(false);
  const [search, setSearch] = React.useState("");
  const [assetData, setAssetData] = useState([{}]);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const renderSourceValue = (value: React.ReactNode) => (
    <SourceValue value={value} />
  );
  const onSearch = (value: string) => {
    setSearchTerm(value);
    setSearch("");
    setPageNumber(1);
  };

  const columns: ColumnsType<any> = [
    {
      title: "FILE NAME",
      dataIndex: "fileName",
      key: "fileName",
      width: 400,
      render: renderSourceValue,
      // render: (_, record) => {
      //   return (
      //     <div className="toUppercase">
      //       <Text>{record.fileName}</Text>
      //     </div>
      //   );
      // },
    },
    {
      title: "ALBUM",
      dataIndex: "album",
      key: "album",
      render: renderSourceValue,

      // render: (_, record) => {
      //   return (
      //     <div className="toUppercase">
      //       <Text>{record.fileName}</Text>
      //     </div>
      //   );
      // },
    },
    {
      title: "REFERENCE #",
      dataIndex: "uploadKey",
      key: "uploadKey",
      width: 250,
      render: renderSourceValue,
    },
    {
      title: "WATERMARK",
      dataIndex: "watermark",
      key: "watermark",
      render: (_, record) => {
        return <StackedText value={record.watermark} />;
      },
    },
    {
      title: "ORIGINAL",
      dataIndex: "format",
      key: "format",
      width: 100,
      render: renderSourceValue,
      // render: (_, record) => {
      //   return (
      //     <div className="toUppercase">
      //       <Text>{record.format}</Text>
      //     </div>
      //   );
      // },
    },
    {
      title: "SIZE",
      dataIndex: "size",
      key: "size",
      render: renderSourceValue,
    },
    {
      title: "STATUS",
      dataIndex: "status",
      key: "status",

      render: (_, record) => {
        return <StackedText value={record.status} />;
      },
    },
  ];
  useEffect(() => {
    setLoading(true);

    const params = {
      // SearchTerm: searchTeam,
      text: searchFilters.searchTerm ? searchFilters.searchTerm : "",
      // start: pageNumber,
      itemsPerPage: itemsPerPage,
      pageNumber: pageNumber,
      sortColumn: "modifiedOn",
      sortOrder: "DESC",
    };
    getApi(params, "/assets/search")
      .then((res) => {
        setLoading(false);
        setAssetData(res.items);
        setTotalItems(res.totalItems);
      })
      .catch((error) => {
        console.log("error feching data", error);
      });
  }, [searchFilters]);
  const setSearchTerm = (searchTerm: string) => {
    setSearchFilters((prev) => ({ ...prev, searchTerm }));
  };
  const clearSearch = () => {
    setSearch("");
    setSearchTerm("");
  };

  const handlePageChange: PaginationProps["onChange"] = (page) => {
    setPageNumber(page);
    setSearchFilters((prev) => ({ ...prev, pageNumber: page }));
  };

  const handleLimitChange = (limit: {
    value: string;
    label: React.ReactNode;
  }) => {
    setItemsPerPage(Number(limit.value));
    setSearchFilters((prev) => ({ ...prev, itemsPerPage: limit.value }));
  };

  return (
    <div
      style={{
        background: "#000000CC",
        minHeight: "700px",
        padding: "80px",
      }}
    >
      <Row>
        <Col span={12}>
          <Title className="page-title">ASSET SEARCH</Title>
        </Col>
        <Col span={12} style={{ display: "flex", justifyContent: "flex-end" }}>
          {/* <Search
            prefix={<SearchOutlined />}
            className="search-input-asset"
            onSearch={onSearch}
            size="large"
            enterButton="Search"
            allowClear
          /> */}
          <Space size={"small"}>
            {/* <Input style={{ width: "400px" }} />
            <Button onClick={()=>onSearch()} type="primary">
              SEARCH
            </Button> */}
            <Search
              prefix={<SearchOutlined />}
              className="search"
              onSearch={onSearch}
              size="large"
              enterButton="SEARCH"
              allowClear
            />
          </Space>
        </Col>
      </Row>
      <br />
      <br />
      <br />

      <div
        style={{
          // background: "#141414",

          padding: "20px",
          marginBottom: "2px",
          borderRadius: "4px",
        }}
      >
        <Row justify="space-evenly">
          <Col span={12}>
            <Text style={{ color: "#4AB2F2" }}>Viewing &nbsp;</Text>
            {""}
            <Select
              labelInValue
              defaultValue={countValues[0]}
              className="itemPerPageFilter"
              onChange={handleLimitChange}
              options={countValues}
            />
            &nbsp;&nbsp;
            <Text style={{ color: "#4AB2F2" }}>of {totalItems} Results</Text>
          </Col>

          <Col span={12} className="paginationAlignment">
            <Row justify="end">
              <Col>
                <Pagination
                  defaultCurrent={1}
                  current={pageNumber}
                  pageSize={itemsPerPage}
                  onChange={handlePageChange}
                  total={totalItems}
                  showSizeChanger={false}
                  responsive={true}
                  showLessItems={true}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <Row>
        <Col span={24}>
          {/* <Table
            columns={teamColumn}
            dataSource={[]}
            pagination={false}
            scroll={{ y: 500 }}
            className="custom-table"
            rowKey={"teamId"}

          /> */}
          {/* <CustomTable dataSource={assetData} /> */}
          <Table
            dataSource={assetData}
            loading={loading}
            columns={columns}
            pagination={false}
            scroll={{ y: 700 }}
            rowHoverable={false}
            locale={{
              emptyText: (
                <Text style={{ textAlign: "center" }}>No Results Found</Text>
              ),
            }}
            rowClassName="custom-row"
            onRow={(record, rowIndex) => {
              return {
                onClick: (event) => {
                  // const modifiedData = { ...record, progress: 100 };
                  // console.log("modified  data--", modifiedData);

                  if (event.target) {
                    if (user.isAdmin) {
                      if (
                        (record.status === "Uploaded" ||
                          record?.status?.toLowerCase()?.includes("failed")) ??
                        false
                      ) {
                        navigate(
                          `/${record.uploadKey}?fileName=${record.fileName}`,
                          {
                            state: {
                              data: record,
                            },
                          },
                        );
                      } else {
                        navigate(
                          `/search/${record.uploadKey}?fileName=${record.fileName}`,
                          {
                            state: {
                              data: record,
                            },
                          },
                        );
                      }
                    }
                  }
                },
                style: { cursor: user.isAdmin ? "pointer" : "default" },
              };
            }}
          />
        </Col>
      </Row>
    </div>
  );
}

export default SearchPage;
